module.exports = __webpack_public_path__ + "img/award_star.2b0f3ee6.svg";